/* Publish by EComposer at 2026-10-21 02:02:21*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-561yro6w52c"]=  window.__ectimmers["ecom-561yro6w52c"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),n=t.querySelector(".text-content.ecom-html");!n||(e&&e.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-561yro6w52c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-561yro6w52c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nou7lpscuv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nou7lpscuv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jrml1rp2yc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jrml1rp2yc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8vxqopeynj6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8vxqopeynj6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6khjzchyr3h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6khjzchyr3h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bmg4sifstyh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bmg4sifstyh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n1doy81jn4f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n1doy81jn4f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vbw24jp4bdc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vbw24jp4bdc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dgaj92nwt08').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dgaj92nwt08', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yo2wv3r9xp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yo2wv3r9xp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-afo3go7wjio').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-afo3go7wjio', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xgnwljffk6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xgnwljffk6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-budosmzx0j7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-budosmzx0j7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vdr8hgftj4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vdr8hgftj4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dh66s4a6sj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dh66s4a6sj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2qurw9swkc9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2qurw9swkc9', settings: {},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}